import { axiosIntance } from '../../../config/ApiConfig';
import { FoodComplementProduct } from '../../../types/foodComplements/interfaces';

export const FoodComplementsRepository = {
  delete: (data: any) => {
    return axiosIntance.delete(`/foodComplements`, {
      data: { id: data._id, ...data },
    });
  },
  create: (form: object) => {
    return axiosIntance.post(`/foodComplements`, form);
  },
  update: (form: object) => {
    return axiosIntance.put(`/foodComplements`, form);
  },
  createMass: (form: object): Promise<FoodComplementProduct[]> => {
    return axiosIntance.post('/foodComplements/mass', form);
  },
};
